import React from "react";

export const CentroMya = (props) => {
  return (
    <div id="empoderamiento">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/Mya2.png" className="img-responsive" style={{marginTop: 100}}alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="empoderamiento-text">
              <h2>Subvención global MYA </h2>
              <h3>2022-2025 </h3>
                <h3>Area de Interés: Alfabetización y educación básica</h3>
                <p>Desarollo de ambientes de formación tecnológica para personas en condición de discapacidad</p>
              <div className="text-justify">
                <div className="col-lg-12 col-sm-12 col-xs-12">
                  <p>
                    Durante este periodo tuvimos la oportunidad de llevar a buen término la Subvención Global No.2348394 “Desarrollo de ambientes tecnológicos en
                    El Centro Mya”, ubicado en Bogotá, para apoyar personas con discapacidad, programa realizado por el Club Rotario Bogotá Centenario en alianza
                    con el Club Rotario de Alpharetta y La Fundación Rotaria, por un valor de USD 30,016. </p>
                     <p> Se inició una Subvención Global para esta institución que alberga y
asiste a más de 100 niños, niñas y jóvenes con discapacidades cerebrales de leves a profundas. Propósito de la Subvención: dotar la sala de cómputo para jóvenes que tienen la posibilidad de aprender lo básico
y prepararlos para que puedan acceder a un trabajo que les permita cierta autonomía. En el mes de diciembre los socios se hicieron presentes en la celebración de la Fiesta
de Navidad con refrigerios y regalos.
                  </p>
                  <p>Puedes encontrar más información de la fundación en el siguiente link: <a href="https://centromya.ong/" target="_blank" rel="noreferrer" > Centro MYA</a></p>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
